;(function () {
  const initSeeFullDetails = () => {
    const seeFullDetailsLinks = document.querySelectorAll('.see-full-details')

    seeFullDetailsLinks.forEach((link) => {
      console.log('See Full Details Link Found:', link) // Debug
      const description = link.previousElementSibling // Assumes .product__description is the previous sibling
      if (description) {
        console.log('Description Element:', description) // Debug
        // Count words to verify visibility (matches Liquid logic)
        const text = description.textContent.trim()
        const wordCount = text.split(/\s+/).filter((word) => word.length > 0).length
        console.log('JS Word Count:', wordCount) // Debug
        if (wordCount <= 30) {
          link.style.display = 'none'
        } else {
          link.addEventListener('click', (event) => {
            event.preventDefault()
            console.log('See Full Details Clicked') // Debug
            const showText = link.querySelector('.text-show')
            const hideText = link.querySelector('.text-hide')
            if (!link.classList.contains('active')) {
              console.log('Expanding description') // Debug
              slideDown(link, description, 300) // Requires slideDown from global.js
              link.classList.add('active')
              showText.style.display = 'none'
              hideText.style.display = 'block'
              link.setAttribute('aria-expanded', 'true')
            } else {
              console.log('Collapsing description') // Debug
              slideUp(link, description, 300) // Requires slideUp from global.js
              link.classList.remove('active')
              showText.style.display = 'block'
              hideText.style.display = 'none'
              link.setAttribute('aria-expanded', 'false')
            }
          })
        }
      } else {
        console.log('No description element found for See Full Details link', link) // Debug
      }
    })
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', () => {
    initSeeFullDetails()
  })

  // Re-initialize on section load (for Shopify section rendering)
  document.addEventListener('shopify:section:load', (event) => {
    initSeeFullDetails()
  })
})()
